import { createContext, FC, useContext, useMemo } from "react";
import { useLoggedinUser } from "lib/hooks";
import { reformatKey } from "./helper";
import { useXdStorageContext } from "lib/storage";
import { userClient } from "lib/clients";
import { generate } from "generate-password-browser";
import getConfig from 'next/config';

const { publicRuntimeConfig: { enableEncryptedPacks } } = getConfig();

const E2EEContext = createContext(null);

export const E2EEProvider: FC = ({ children }) => {
  const { data, error } = useLoggedinUser();
  const { isLoaded: isStorageLoaded, storage, setItem } = useXdStorageContext();

  const hasHashPassword = typeof window !== 'undefined' && window.location.hash?.slice(1)?.length > 0;
  const isEncryptedUser = !!data?.nonce_key_armored && !!data?.public_key_armored && !!data?.key_id && isStorageLoaded && !!storage.packs_nonce;
  const isLoaded = (!!data || !!error) && isStorageLoaded;
  const needNonce = !hasHashPassword && isLoaded && (!data?.nonce_key_armored || !storage.packs_nonce?.length);
  const needPassword = !hasHashPassword && isLoaded && !data?.has_password;

  const keys = useMemo(() => ({
    id: data?.key_id,
    private: data?.privateKey,
    public: data?.publicKey,
    needNonce
  }), [data, needNonce]);

  const createNonce = async (user: any, password: string) => {
    const nonce = generate({ length: 32, numbers: true, excludeSimilarCharacters: false, symbols: false });

    const nonceKey = await reformatKey(user, password, nonce);

    const { data: updatedUser } = await userClient.createNonce(nonceKey);

    await setItem('packs_nonce', nonce);

    return updatedUser;
  }

  return (
    <E2EEContext.Provider value={{ createNonce, key_id: data?.key_id, keys, isEncryptedUser, isLoaded, needNonce, needPassword, enableEncryptedPacks }}>
      {children}
    </E2EEContext.Provider>
  )
};

export const useE2EEContext = () => useContext(E2EEContext);
